import FormMakeAppointment from '../components/forms/FormMakeAppointment';

if (document.getElementById('form-appoinment')) {
  new Vue({
    el: '#form-appoinment',
    components: {
      FormMakeAppointment
    },
  });
}


// WEBPACK FOOTER //
// ./resources/assets/js/snippets/form-appoinment.js